import { ErrorResponse, SoProcessTypesEnum, StatusEnum } from '@gtpl/shared-models/common-models';
import { LocationUpdateRequest } from '@gtpl/shared-models/procurement-management';
import { RMFiltersRequest } from '@gtpl/shared-models/raw-material-procurement';
import { BomUpdateRequest, CommonResponse } from '@gtpl/shared-models/sale-management';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { Repository, EntityRepository, Raw } from 'typeorm';
import { BomDetails } from '../bom-calculation.entity';
import { BomIdsRequest } from '../dto/bom-ids.request';
import { ReProcessRequiredQty } from '../dto/re-processing-required-qty.request';
import { SaleOrderIdRequest } from '../dto/sale-order-id.request';
import { SaleOrderIdsRequest } from '../dto/sale-order-ids.request';
import { SoInvoiceDetails } from '../sale-invoice-details.entity';
import { SoInvoiceRepository } from './so-inv-details-repository';
import { SoRepository } from './so-repository';
import { SoTrackRepository } from './so-track-repository';


@EntityRepository(BomDetails)
export class BomRepository extends Repository<BomDetails>{

    async BomDetailsForSo(saleOrderIdRequest: SaleOrderIdRequest) {
        try {
            console.log(saleOrderIdRequest.saleOrderId);
            const response: BomDetails[] = await this.createQueryBuilder('bom_details')
                // .select('bom_details.packing_material_id as packingMaterialId, bom_details.item_category_id as itemCategoryId, bom_details.sale_order_id as saleOrderId, bom_details.item_id as itemId, bom_details.size, bom_details.packing_category as packingCategory, bom_details.quantity, bom_details.existing_qty as avilableQuantity, bom_details.status, bom_details.required_qty as requiredQuantity, bom_details.is_active as isActive')
                .leftJoinAndSelect('bom_details.saleOrderInfo', 'saleOrderInfo')
                .where(`bom_details.sale_order_id = '${saleOrderIdRequest.saleOrderId}' and packing_category is not null`)
                .getMany();
            return response;
        } catch (error) {
            return error;
        }
    }

    async getBomQty(itemCategoryId: number) {
        try {
            const bomEntity = await this.createQueryBuilder("bom_details")
                .select('sum(bom_details.required_qty) as totalbomQty')
                .where(`item_category_id= ${itemCategoryId} and bom_details.is_active=true`)
                .getRawOne();
            if (bomEntity) {
                return bomEntity;
            } else {
                return null;
            }
        } catch (err) {
            return err
        }
    }

    async getdynamicBomdata(itemCategoryId: number, fromDate: any, toDate: any, column: string) {
        const soItemEntity = await this.createQueryBuilder("bom_details")
            .select('bom_details.packing_material_id as bomId,bom_details.item_id as itemId,sum(bom_details.required_qty) as bomQty,SoInvDetailsInfo.country_id as countryId,SoInvDetailsInfo.po_number as poNumber,SoPoDetailsInfo.certification_id as certificationId,SoPoDetailsInfo.rating')
            .leftJoin('bom_details.saleOrderInfo', 'saleOrderInfo')
            .leftJoin('saleOrderInfo.SoPoDetailsInfo', 'SoPoDetailsInfo')
            .leftJoin('saleOrderInfo.SoInvDetailsInfo', 'SoInvDetailsInfo')
            .where(`item_category_id= ${itemCategoryId} and bom_details.is_active=true`);

        if (!toDate) {
            soItemEntity.andWhere(`Date(SoInvDetailsInfo.edl_date) > '${fromDate}'`)
        } else {
            soItemEntity.andWhere(`Date(SoInvDetailsInfo.edl_date) BETWEEN '${fromDate}' AND '${toDate}'`)
        }


        // if(req.countryId > 0){
        //     soItemEntity.andWhere(`SoInvDetailsInfo.country_id = ${req.countryId}`)
        // }
        // if(req.rating > 0){
        //     soItemEntity.andWhere(`SoPoDetailsInfo.rating = ${req.rating}`)
        // }
        // if(req.poNumber){
        //     soItemEntity.andWhere(`SoInvDetailsInfo.po_number = '${req.poNumber}'`)
        // }
        // if(req.maxCount>0 && req.maxCount>0){
        //     soItemEntity.andWhere(`SoInvDetailsInfo.po_number = '${req.poNumber}'`)
        // }
        const bomEntity = await soItemEntity.groupBy(`'bom_details.itemId,${[column]}'`)
            .getRawMany();
        return bomEntity;
    }


    async getRmBomInfo(itemCategoryId: number, fromDate: any, toDate: any, req: RMFiltersRequest) {
        try {
            const soItemEntity = await this.createQueryBuilder("bom_details")
                .select('bom_details.packing_material_id as bomId,bom_details.item_id as itemId,sum(bom_details.required_qty) as bomQty,SoInvDetailsInfo.country_id as countryId,SoPoDetailsInfo.certification_id as certificationId,SoPoDetailsInfo.rating')
                .leftJoin('bom_details.saleOrderInfo', 'saleOrderInfo')
                .leftJoin('saleOrderInfo.SoPoDetailsInfo', 'SoPoDetailsInfo')
                .leftJoin('saleOrderInfo.SoInvDetailsInfo', 'SoInvDetailsInfo')
                .where(`item_category_id= ${itemCategoryId} and bom_details.is_active=true`);

            if (!toDate) {
                soItemEntity.andWhere(`Date(SoInvDetailsInfo.edl_date) > '${fromDate}'`)
            } else {
                soItemEntity.andWhere(`Date(SoInvDetailsInfo.edl_date) BETWEEN '${fromDate}' AND '${toDate}'`)
            }

            if (req.countryId > 0) {
                soItemEntity.andWhere(`SoInvDetailsInfo.country_id = ${req.countryId}`)
            }
            if (req.rating > 0) {
                soItemEntity.andWhere(`SoPoDetailsInfo.rating = ${req.rating}`)
            }
            if (req.poNumber) {
                soItemEntity.andWhere(`SoInvDetailsInfo.po_number = '${req.poNumber}'`)
            }
            // if(req.maxCount>0 && req.maxCount>0){
            //     soItemEntity.andWhere(`SoInvDetailsInfo.po_number = '${req.poNumber}'`)
            // }
            const bomEntity = await soItemEntity.groupBy('bom_details.itemId')
                .getRawMany();
            return bomEntity;
        } catch (error) {
            return error;
        }
    }

    async getReProcessingRequiredQuantity(saleOrderId: number) {
        try {
            const response: BomDetails[] = await this.createQueryBuilder('bom_details')
                .where(`bom_details.sale_order_id = '${saleOrderId}' and packing_category is null`)
                .getMany();
            return response;
        } catch (error) {
            return error;
        }
    }

    async BomDetailsForSoInPO(saleOrderIdRequest: SaleOrderIdsRequest) {
        try {
            console.log(saleOrderIdRequest.saleOrderId);
            const response: BomDetails[] = await this.createQueryBuilder('bom_details')
                // .select('bom_details.packing_material_id as packingMaterialId, bom_details.item_category_id as itemCategoryId, bom_details.sale_order_id as saleOrderId, bom_details.item_id as itemId, bom_details.size, bom_details.packing_category as packingCategory, bom_details.quantity, bom_details.existing_qty as avilableQuantity, bom_details.status, bom_details.required_qty as requiredQuantity, bom_details.is_active as isActive')
                .leftJoinAndSelect('bom_details.saleOrderInfo', 'saleOrderInfo')
                .leftJoinAndSelect('saleOrderInfo.SoInvDetailsInfo', 'SoInvDetailsInfo')
                .where(`bom_details.sale_order_id IN(${saleOrderIdRequest.saleOrderId}) and bom_details.required_qty>0 and bom_details.is_active=1 and packing_category is not null`)
                .getMany();
            return response;
        } catch (error) {
            return error;
        }
    }

    async BomDetailsForSoInPackingBom(bomReq: BomIdsRequest) {
        const response: BomDetails[] = await this.createQueryBuilder('bom_details')
            .leftJoinAndSelect('bom_details.saleOrderInfo', 'saleOrderInfo')
            .leftJoinAndSelect('saleOrderInfo.SoInvDetailsInfo', 'SoInvDetailsInfo')
            .where(`bom_details.packing_material_id IN(${bomReq.packingMaterialId}) and bom_details.required_qty>0 and bom_details.is_active=1 and packing_category is not null`)
            .getMany();
        return response;
    }

    async BomDetailsForItemCodeAndUnit(itemCodes: number[], unit: number) {
        const response: BomDetails[] = await this.createQueryBuilder('bom_details')
            .leftJoinAndSelect('bom_details.saleOrderInfo', 'saleOrderInfo')
            .leftJoinAndSelect('saleOrderInfo.SoInvDetailsInfo', 'soi')
            .where(`bom_details.item_id IN (:...itemCodes) and bom_details.is_active=1 and packing_category is not null and soi.processing_unit = ${unit}`, {itemCodes: itemCodes })
            // get only pending requests, where we haven't created a PO for the BOM
            .andWhere(`bom_details.required_qty > 0 `)
            .orderBy(`soi.edl_date`, 'ASC')
            .getMany();
        return response;
    }

    async UpdateBomDetailsForSoInPO(saleOrderIdRequest: SaleOrderIdRequest) {
        try {
            const response: BomDetails[] = await this.createQueryBuilder('bom_details')
                // .select('bom_details.packing_material_id as packingMaterialId, bom_details.item_category_id as itemCategoryId, bom_details.sale_order_id as saleOrderId, bom_details.item_id as itemId, bom_details.size, bom_details.packing_category as packingCategory, bom_details.quantity, bom_details.existing_qty as avilableQuantity, bom_details.status, bom_details.required_qty as requiredQuantity, bom_details.is_active as isActive')
                .leftJoinAndSelect('bom_details.saleOrderInfo', 'saleOrderInfo')
                .where(`bom_details.sale_order_id IN(${saleOrderIdRequest.saleOrderId}) and bom_details.required_qty>0 and bom_details.is_active=1 and packing_category is not null`)
                .getMany();
            return response;
        } catch (error) {
            return error;
        }
    }

    async updateBomReceivedQty(req: BomUpdateRequest): Promise<boolean> {
        try {

            const bomData = await this.findOne({ select: ['requiredQuantity', 'receivedQuantity', 'AssignedQuantity'], where: { saleOrderId: req.saleOrderId, itemId: req.itemId } })
            let bomStatus = StatusEnum.GRN;
            let req_qty = bomData.requiredQuantity;
            if (bomData) {
                if (Number(bomData.requiredQuantity) >= (Number(req.acceptedQuantity) + Number(bomData.AssignedQuantity))) {
                    console.log('greater')
                    req_qty = req.acceptedQuantity
                    if (Number(bomData.requiredQuantity) - (Number(req.acceptedQuantity + Number(bomData.AssignedQuantity))) == 0) {
                        bomStatus = StatusEnum.CLOSED;
                    }
                } else {
                    bomStatus = StatusEnum.CLOSED;
                }
                const updatedBom = await this.update({ saleOrderId: req.saleOrderId, itemId: req.itemId }, { receivedQuantity: () => `receiced_qty+${req.acceptedQuantity}`, requiredQuantity: () => `required_qty-${req_qty}`, status: bomStatus })
                // const updatedBom =  await this.update({saleOrderId:req.saleOrderId,itemId:req.itemId},{ receivedQuantity: Raw(receivedQuantity => receivedQuantity+req.acceptedQuantity)} );
                if (updatedBom) {
                    return true;
                } else {
                    return false;
                }

            } else {
                return false;
            }


        } catch (err) {
            return err;
        }

    }

    async updateBomAssignedQty(req: BomUpdateRequest): Promise<boolean> {
        const manager = new GenericTransactionManager();
        try {

            let bomStatus = StatusEnum.ASSIGNED
            const bomData = await this.findOne({ select: ['requiredQuantity', 'receivedQuantity', 'status', 'AssignedQuantity'], where: { saleOrderId: req.saleOrderId, itemId: req.itemId } })
            let req_qty = bomData.requiredQuantity;


            if (bomData) {
                if (Number(bomData.requiredQuantity) - Number(req.acceptedQuantity) > 0) {
                    req_qty = req.acceptedQuantity
                } else {
                    bomStatus = StatusEnum.CLOSED;
                }
            }
            await manager.startTransaction();
            const updatedBom = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.saleOrderId, itemId: req.itemId }, { AssignedQuantity: () => `assigned_qty+${req.acceptedQuantity}`, requiredQuantity: () => `required_qty-${req_qty}`, status: bomStatus });

            // const updatedBom =  await this.update({saleOrderId:req.saleOrderId,itemId:req.itemId},{ receivedQuantity: Raw(receivedQuantity => receivedQuantity+req.acceptedQuantity)} );
            if (updatedBom.affected) {
                manager.completeTransaction();
                return true;
            } else {
                throw new ErrorResponse(9999, 'Failed To Update Bom');
            }
        } catch (err) {
            manager.releaseTransaction();
            return false;
        }

    }

    async packingRequirementForMonthly() {
        try {
            const Info = await this.createQueryBuilder('bom_details')
                .select('MONTHNAME(created_at) as month, packing_category as packingCategory, round(sum(required_qty)) as requiredQuantity')
                .where(`bom_details.required_qty>0  and bom_details.is_active=1 and packing_category is not null AND YEAR(created_at)=YEAR(CURDATE())`)
                .groupBy('packing_category, MONTH(created_at)')
                .orderBy('MONTH(created_at)')
                .getRawMany();


            const months = await this.createQueryBuilder('bom_details')
                .select('MONTHNAME(created_at) month')
                .where(`bom_details.required_qty>0  and bom_details.is_active=1 and packing_category is not null AND YEAR(created_at)=YEAR(CURDATE())`)
                .groupBy('MONTHNAME(created_at)')
                .orderBy('MONTH(created_at)')
                .getRawMany();

            const names = await this.createQueryBuilder('bom_details')
                .select('packing_category as packingCategory')
                .where(`bom_details.required_qty>0  and bom_details.is_active=1 and packing_category is not null AND YEAR(created_at)=YEAR(CURDATE())`)
                .groupBy('packing_category')
                .orderBy('MONTH(created_at)')
                .getRawMany();

            return { data: Info, months: months, packingCat: names };
        } catch (error) {
            return error;
        }
    }

    async BomDetailsForSoPacking() {
        try {
            // console.log(saleOrderIdRequest.saleOrderId);
            const response: BomDetails[] = await this.createQueryBuilder('bom_details')
                // .select('bom_details.packing_material_id as packingMaterialId, bom_details.item_category_id as itemCategoryId, bom_details.sale_order_id as saleOrderId, bom_details.item_id as itemId, bom_details.size, bom_details.packing_category as packingCategory, bom_details.quantity, bom_details.existing_qty as avilableQuantity, bom_details.status, bom_details.required_qty as requiredQuantity, bom_details.is_active as isActive')
                .leftJoinAndSelect('bom_details.saleOrderInfo', 'saleOrderInfo')
                .where( ` packing_category is not null`)
                .getMany();
            return response;
        } catch (error) {
            return error;
        }
    }

    async isStockAssignedForSO(req: SaleOrderIdRequest):Promise<CommonResponse>{
        try{
            const bomDetails = this.createQueryBuilder("BomDetails")
            .where(`packing_category is not null`)
            .andWhere(`sale_order_id = `+req.saleOrderId).andWhere(`assigned_qty>0`)
            const bomInfo = await bomDetails.getMany();
            if(bomInfo.length > 0){
                return new CommonResponse(true,555,'assigned')
            }else{
                return new CommonResponse(false,111,'not assigned')
            }
        }catch(err){
            return new CommonResponse(false,122,err)
        }
     }
     async updateAssignedAndRequiredQty(req: LocationUpdateRequest):Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            let getPoNumber = await manager.getCustomRepository(SoInvoiceRepository).findOne({where:{saleOrderId:req.saleOrderId}});
            let getPoNumberForMainJob = await manager.getCustomRepository(SoInvoiceRepository).findOne({where:{poNumber :getPoNumber.poNumber, jobType:"Main Job"}});
            if(getPoNumber.jobType === "Main Job"){
                req.saleOrderId = req.saleOrderId;
            }
            else{
                req.saleOrderId = getPoNumberForMainJob.saleOrderId;
            }
            let flag = true;
            let bomStatusFlag = new Set<boolean>()
            const getBomDetails = await manager.getCustomRepository(BomRepository).findOne({ where: { itemId: req.itemId, itemCategoryId: req.itemCategoryId, itemSubCategoryId: req.itemSubCategoryId, saleOrderId: req.saleOrderId } })
                if (getBomDetails.requiredQuantity - req.quantity > 0) {
                    bomStatusFlag.add(false)
                } else {
                    bomStatusFlag.add(true)
                }
                let updateBom
                if (!(bomStatusFlag.has(false))) {
                    updateBom = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.saleOrderId, itemId: req.itemId, itemCategoryId: req.itemCategoryId, itemSubCategoryId: req.itemSubCategoryId }, { AssignedQuantity: () => `assigned_qty+${req.quantity}`, requiredQuantity: () => `quantity-${req.quantity}`, status: StatusEnum.CLOSED });
                } else {
                    updateBom = await manager.getCustomRepository(BomRepository).update({ saleOrderId: req.saleOrderId, itemId: req.itemId, itemCategoryId: req.itemCategoryId, itemSubCategoryId: req.itemSubCategoryId }, { AssignedQuantity: req.quantity, requiredQuantity: () => `quantity-${req.quantity}` });
                }
                if (!updateBom) {
                    flag = false;
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 1010, "Something went wrong with update BOM. ");
                }
                else{
                    manager.completeTransaction();
                    return new CommonResponse(true,1001,"Update successfull. ");
                }
        } catch (error) {
            return error;
        }
    }


}
